module.exports = __webpack_public_path__ + "02334ea50a73d1a503e8f04733cc2f68.png";